<div>
    <app-p-player [store_id]="store_id" [slick_id]="slick_id" [widget_id]="widget_id"></app-p-player>
</div>
